export default __webpack_public_path__ + "static/media/cart-03-EN.70a5105b.jpg";